import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { loadFirebaseConfig } from './app/firebase-runtime-config';

if (environment.production) {
  enableProdMode();
  if (window) {
    window.console.log = function () { };
  }
}

// The Firebase project comes from the backend (its EnvironmentName), so load it before the app starts.
loadFirebaseConfig().then(() => platformBrowserDynamic().bootstrapModule(AppModule)).then(ref => {
  // Ensure Angular destroys itself on hot reloads.
  if (window['ngRef']) {
    window['ngRef'].destroy();
  }
  window['ngRef'] = ref;

  // Otherwise, log the boot error
}).catch(err => console.error(err));